'use client';

import Icon from '@/lib/Icon/Icon';

interface InfoBoxProps {
  variant: 'info' | 'warning';
  children: string;
}

const InfoBox: React.FC<InfoBoxProps> = ({ variant, children }) => {
  return (
    <div
      className={`flex gap-2 px-2 py-1.5 rounded-lg
        ${variant === 'warning' && 'bg-surface-notice-faded'}
        ${variant === 'info' && 'bg-information-faded'}
     `}
    >
      <Icon className="mt-0.5 shrink-0" name={variant} />
      <p
        className={`text-sm font-medium 
         ${variant === 'warning' && 'text-on-notice-intense'}
         ${variant === 'info' && 'text-information-intense'}
       `}
      >
        {children}
      </p>
    </div>
  );
};

export default InfoBox;
